import classnames from 'classnames';
import { numFormat } from '@uno-next/utils';
import classes from './index.module.scss';

import type { CSSProperties, PropsWithChildren } from 'react';
import { isQuotation } from '@/helper';

interface IPriceProps extends PropsWithChildren {
  className?: string;
  symbol?: string;
  symbolClassName?: string;
  price: number;
  isFormat?: number | boolean;
  decoration?: CSSProperties['textDecorationLine'];
}

const Price = (props: IPriceProps) => {
  const { className, symbol = '￥', symbolClassName, price, decoration, isFormat = 10000 } = props;
  // 当前价格是否为询价产品
  const isQuotationPrice = isQuotation(price);

  return (
    <span
      className={classnames(classes.wrap, className)}
      style={{ textDecorationLine: decoration }}>
      {symbol && !isQuotationPrice ? (
        <i className={(classes.symbol, symbolClassName)}>{symbol}</i>
      ) : null}
      {isQuotationPrice ? <span>询价产品</span> : numFormat(isFormat ? price / Number(isFormat) : price)}
    </span>
  );
};

export default Price;
